import { render } from "./OfficeRequisicaoCompraTab.vue?vue&type=template&id=9ff2bda0&scoped=true&ts=true"
import script from "./OfficeRequisicaoCompraTab.vue?vue&type=script&lang=ts"
export * from "./OfficeRequisicaoCompraTab.vue?vue&type=script&lang=ts"

import "./OfficeRequisicaoCompraTab.vue?vue&type=style&index=0&id=9ff2bda0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff2bda0"]])

export default __exports__